import React from 'react'
import { matchPath } from 'react-router-dom'
import type { PageComponent } from 'src/types/common/component'

import PermissionGuardRoute from './PermissionGuardRoute'
import { fullModalRoutes } from './RouteName'

export const produceRoutes = (routes: { [routeName: string]: PageComponent }) =>
  Object.entries(routes).map(([path, component]) => (
    <PermissionGuardRoute
      key={path}
      data-mathflat-unique-id={path}
      path={path}
      component={component}
    />
  ))

export const isFullModalRoutes = (pathname: string) => {
  return fullModalRoutes.some((publicRoute) =>
    matchPath(pathname, {
      path: publicRoute,
    }),
  )
}
